// @generated by protoc-gen-es v1.9.0 with parameter "target=ts"
// @generated from file no/jotta/openapi/config/v2/config.v2.proto (package no.jotta.openapi.config.v2, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { Message, proto3 } from "@bufbuild/protobuf";
import { Language } from "../../language_pb.js";
import { Country } from "../../country_pb.js";
import { Feature } from "../../feature/v2/feature.v2_pb.js";
/**
 * @generated from enum no.jotta.openapi.config.v2.InputFieldVisibility
 */
export var InputFieldVisibility;
(function (InputFieldVisibility) {
    /**
     * @generated from enum value: ENABLED = 0;
     */
    InputFieldVisibility[InputFieldVisibility["ENABLED"] = 0] = "ENABLED";
    /**
     * @generated from enum value: DISABLED = 1;
     */
    InputFieldVisibility[InputFieldVisibility["DISABLED"] = 1] = "DISABLED";
    /**
     * @generated from enum value: HIDDEN = 2;
     */
    InputFieldVisibility[InputFieldVisibility["HIDDEN"] = 2] = "HIDDEN";
})(InputFieldVisibility || (InputFieldVisibility = {}));
// Retrieve enum metadata with: proto3.getEnumType(InputFieldVisibility)
proto3.util.setEnumType(InputFieldVisibility, "no.jotta.openapi.config.v2.InputFieldVisibility", [
    { no: 0, name: "ENABLED" },
    { no: 1, name: "DISABLED" },
    { no: 2, name: "HIDDEN" },
]);
/**
 * @generated from message no.jotta.openapi.config.v2.SupportChannel
 */
export class SupportChannel extends Message {
    /**
     * @generated from oneof no.jotta.openapi.config.v2.SupportChannel.type
     */
    type = { case: undefined };
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.config.v2.SupportChannel";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "intercom", kind: "message", T: SupportChannel_Intercom, oneof: "type" },
        { no: 2, name: "phone", kind: "message", T: SupportChannel_Phone, oneof: "type" },
        { no: 3, name: "email", kind: "message", T: SupportChannel_Email, oneof: "type" },
        { no: 4, name: "web", kind: "message", T: SupportChannel_Web, oneof: "type" },
    ]);
    static fromBinary(bytes, options) {
        return new SupportChannel().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SupportChannel().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SupportChannel().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SupportChannel, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.config.v2.SupportChannel.Intercom
 */
export class SupportChannel_Intercom extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.config.v2.SupportChannel.Intercom";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new SupportChannel_Intercom().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SupportChannel_Intercom().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SupportChannel_Intercom().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SupportChannel_Intercom, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.config.v2.SupportChannel.Phone
 */
export class SupportChannel_Phone extends Message {
    /**
     * On the form "+47 123 45 678"
     *
     * @generated from field: string phone_number_formatted = 1;
     */
    phoneNumberFormatted = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.config.v2.SupportChannel.Phone";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "phone_number_formatted", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new SupportChannel_Phone().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SupportChannel_Phone().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SupportChannel_Phone().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SupportChannel_Phone, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.config.v2.SupportChannel.Email
 */
export class SupportChannel_Email extends Message {
    /**
     * @generated from field: string email_address = 1;
     */
    emailAddress = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.config.v2.SupportChannel.Email";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "email_address", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new SupportChannel_Email().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SupportChannel_Email().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SupportChannel_Email().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SupportChannel_Email, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.config.v2.SupportChannel.Web
 */
export class SupportChannel_Web extends Message {
    /**
     * @generated from field: string url = 1;
     */
    url = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.config.v2.SupportChannel.Web";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new SupportChannel_Web().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SupportChannel_Web().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SupportChannel_Web().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SupportChannel_Web, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.config.v2.BrandingInfo
 */
export class BrandingInfo extends Message {
    /**
     * @generated from field: string brand_code = 1;
     */
    brandCode = "";
    /**
     * @generated from field: string brand_name = 2;
     */
    brandName = "";
    /**
     * @generated from field: string customer_group_code = 3;
     */
    customerGroupCode = "";
    /**
     * @generated from field: string customer_group_name = 4;
     */
    customerGroupName = "";
    /**
     * @generated from field: no.jotta.openapi.Language default_language = 5;
     */
    defaultLanguage = Language.UNKNOWN_LANGUAGE;
    /**
     * @generated from field: no.jotta.openapi.Country default_country = 6;
     */
    defaultCountry = Country.UNKNOWN_COUNTRY;
    /**
     * @generated from field: string download_mac_link = 20;
     */
    downloadMacLink = "";
    /**
     * @generated from field: string download_win_link = 21;
     */
    downloadWinLink = "";
    /**
     * @generated from field: string download_ios_link = 22;
     */
    downloadIosLink = "";
    /**
     * @generated from field: string download_android_link = 23;
     */
    downloadAndroidLink = "";
    /**
     * @generated from field: string facebook_link = 30;
     */
    facebookLink = "";
    /**
     * @generated from field: string twitter_link = 31;
     */
    twitterLink = "";
    /**
     * @generated from field: string homepage_link = 32;
     */
    homepageLink = "";
    /**
     * @generated from field: string terms_link = 33;
     */
    termsLink = "";
    /**
     * @generated from field: string privacy_link = 34;
     */
    privacyLink = "";
    /**
     * @generated from field: string faq_link = 35;
     */
    faqLink = "";
    /**
     * @generated from field: string upgrade_link = 36;
     */
    upgradeLink = "";
    /**
     * @generated from field: string download_page_link = 37;
     */
    downloadPageLink = "";
    /**
     * @generated from field: string stripe_public_key = 38;
     */
    stripePublicKey = "";
    /**
     * @generated from field: string support_link = 39;
     */
    supportLink = "";
    /**
     * @generated from field: string about_us_link = 40;
     */
    aboutUsLink = "";
    /**
     * @generated from field: string blog_link = 41;
     */
    blogLink = "";
    /**
     * @generated from field: string cli_installation_instructions_link = 42;
     */
    cliInstallationInstructionsLink = "";
    /**
     * @generated from field: string pricing_link = 43;
     */
    pricingLink = "";
    /**
     * @generated from field: string partner_info_link = 44;
     */
    partnerInfoLink = "";
    /**
     * @generated from field: string cookie_policy_link = 45;
     */
    cookiePolicyLink = "";
    /**
     * @generated from field: string signup_free_link = 46;
     */
    signupFreeLink = "";
    /**
     * @generated from field: string signup_business_link = 47;
     */
    signupBusinessLink = "";
    /**
     * @generated from field: string account_termination_link = 48;
     */
    accountTerminationLink = "";
    /**
     * domain postfixes for active, trusted domains. Example: .jottacloud.com
     *
     * @generated from field: repeated string active_domain_postfix = 49;
     */
    activeDomainPostfix = [];
    /**
     * active, trusted domains. Example: www.jottacloud.com
     *
     * @generated from field: repeated string active_domain = 50;
     */
    activeDomain = [];
    /**
     * @generated from field: string download_cli_link = 51;
     */
    downloadCliLink = "";
    /**
     * @generated from field: optional string edit_profile_link = 52;
     */
    editProfileLink;
    /**
     * @generated from field: optional string intercom_app_id = 53;
     */
    intercomAppId;
    /**
     * @generated from field: string oidc_issuer_url = 54;
     */
    oidcIssuerUrl = "";
    /**
     * @generated from field: repeated no.jotta.openapi.config.v2.SupportChannel support_channels = 55;
     */
    supportChannels = [];
    /**
     * @generated from field: string learn_more_sync_link = 56;
     */
    learnMoreSyncLink = "";
    /**
     * @generated from field: string learn_more_backup_link = 57;
     */
    learnMoreBackupLink = "";
    /**
     * @generated from field: string learn_more_selective_sync_link = 58;
     */
    learnMoreSelectiveSyncLink = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.config.v2.BrandingInfo";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "brand_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "brand_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 3, name: "customer_group_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 4, name: "customer_group_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 5, name: "default_language", kind: "enum", T: proto3.getEnumType(Language) },
        { no: 6, name: "default_country", kind: "enum", T: proto3.getEnumType(Country) },
        { no: 20, name: "download_mac_link", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 21, name: "download_win_link", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 22, name: "download_ios_link", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 23, name: "download_android_link", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 30, name: "facebook_link", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 31, name: "twitter_link", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 32, name: "homepage_link", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 33, name: "terms_link", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 34, name: "privacy_link", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 35, name: "faq_link", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 36, name: "upgrade_link", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 37, name: "download_page_link", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 38, name: "stripe_public_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 39, name: "support_link", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 40, name: "about_us_link", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 41, name: "blog_link", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 42, name: "cli_installation_instructions_link", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 43, name: "pricing_link", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 44, name: "partner_info_link", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 45, name: "cookie_policy_link", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 46, name: "signup_free_link", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 47, name: "signup_business_link", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 48, name: "account_termination_link", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 49, name: "active_domain_postfix", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
        { no: 50, name: "active_domain", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
        { no: 51, name: "download_cli_link", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 52, name: "edit_profile_link", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
        { no: 53, name: "intercom_app_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
        { no: 54, name: "oidc_issuer_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 55, name: "support_channels", kind: "message", T: SupportChannel, repeated: true },
        { no: 56, name: "learn_more_sync_link", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 57, name: "learn_more_backup_link", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 58, name: "learn_more_selective_sync_link", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new BrandingInfo().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BrandingInfo().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BrandingInfo().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BrandingInfo, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.config.v2.InputFieldConfig
 */
export class InputFieldConfig extends Message {
    /**
     * @generated from field: no.jotta.openapi.config.v2.InputFieldVisibility input_field_email = 1;
     */
    inputFieldEmail = InputFieldVisibility.ENABLED;
    /**
     * @generated from field: no.jotta.openapi.config.v2.InputFieldVisibility input_field_name = 2;
     */
    inputFieldName = InputFieldVisibility.ENABLED;
    /**
     * @generated from field: no.jotta.openapi.config.v2.InputFieldVisibility input_field_phone = 3;
     */
    inputFieldPhone = InputFieldVisibility.ENABLED;
    /**
     * @generated from field: no.jotta.openapi.config.v2.InputFieldVisibility input_field_country = 4;
     */
    inputFieldCountry = InputFieldVisibility.ENABLED;
    /**
     * @generated from field: no.jotta.openapi.config.v2.InputFieldVisibility input_field_language = 5;
     */
    inputFieldLanguage = InputFieldVisibility.ENABLED;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.config.v2.InputFieldConfig";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "input_field_email", kind: "enum", T: proto3.getEnumType(InputFieldVisibility) },
        { no: 2, name: "input_field_name", kind: "enum", T: proto3.getEnumType(InputFieldVisibility) },
        { no: 3, name: "input_field_phone", kind: "enum", T: proto3.getEnumType(InputFieldVisibility) },
        { no: 4, name: "input_field_country", kind: "enum", T: proto3.getEnumType(InputFieldVisibility) },
        { no: 5, name: "input_field_language", kind: "enum", T: proto3.getEnumType(InputFieldVisibility) },
    ]);
    static fromBinary(bytes, options) {
        return new InputFieldConfig().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InputFieldConfig().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InputFieldConfig().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(InputFieldConfig, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.config.v2.ViewConfig
 */
export class ViewConfig extends Message {
    /**
     * @generated from field: bool show_family_picture = 1;
     */
    showFamilyPicture = false;
    /**
     * @generated from field: bool invite_family_member_by_sms = 2;
     */
    inviteFamilyMemberBySms = false;
    /**
     * @generated from field: bool show_linked_accounts = 3;
     */
    showLinkedAccounts = false;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.config.v2.ViewConfig";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "show_family_picture", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
        { no: 2, name: "invite_family_member_by_sms", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
        { no: 3, name: "show_linked_accounts", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    ]);
    static fromBinary(bytes, options) {
        return new ViewConfig().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ViewConfig().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ViewConfig().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ViewConfig, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.config.v2.GetConfigRequest
 */
export class GetConfigRequest extends Message {
    /**
     * @generated from field: repeated string feature_toggle_ids = 1;
     */
    featureToggleIds = [];
    /**
     * optional, may affect feature toggles
     *
     * @generated from field: optional string hostname = 2;
     */
    hostname;
    /**
     * @generated from field: optional no.jotta.openapi.Language preferred_language = 3;
     */
    preferredLanguage;
    /**
     * optional, takes precedence over hostname for resolving branding_info if set
     *
     * @generated from field: optional string customer_group_code = 4;
     */
    customerGroupCode;
    /**
     * @generated from field: optional no.jotta.openapi.Country country = 5;
     */
    country;
    /**
     * @generated from field: optional string brand_code = 6;
     */
    brandCode;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.config.v2.GetConfigRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "feature_toggle_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
        { no: 2, name: "hostname", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
        { no: 3, name: "preferred_language", kind: "enum", T: proto3.getEnumType(Language), opt: true },
        { no: 4, name: "customer_group_code", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
        { no: 5, name: "country", kind: "enum", T: proto3.getEnumType(Country), opt: true },
        { no: 6, name: "brand_code", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    ]);
    static fromBinary(bytes, options) {
        return new GetConfigRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetConfigRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetConfigRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetConfigRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.config.v2.GetConfigResponse
 */
export class GetConfigResponse extends Message {
    /**
     * @generated from field: repeated string active_feature_toggle_ids = 1;
     */
    activeFeatureToggleIds = [];
    /**
     * @generated from field: repeated no.jotta.openapi.feature.v2.Feature active_features = 2;
     */
    activeFeatures = [];
    /**
     * @generated from field: no.jotta.openapi.config.v2.BrandingInfo branding_info = 3;
     */
    brandingInfo;
    /**
     * @generated from field: no.jotta.openapi.config.v2.InputFieldConfig input_fields_config = 4;
     */
    inputFieldsConfig;
    /**
     * @generated from field: no.jotta.openapi.config.v2.ViewConfig view_config = 5;
     */
    viewConfig;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.config.v2.GetConfigResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "active_feature_toggle_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
        { no: 2, name: "active_features", kind: "enum", T: proto3.getEnumType(Feature), repeated: true },
        { no: 3, name: "branding_info", kind: "message", T: BrandingInfo },
        { no: 4, name: "input_fields_config", kind: "message", T: InputFieldConfig },
        { no: 5, name: "view_config", kind: "message", T: ViewConfig },
    ]);
    static fromBinary(bytes, options) {
        return new GetConfigResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetConfigResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetConfigResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetConfigResponse, a, b);
    }
}
